import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import AdminLayout from '../../components/AdminLayout';
import { Card } from '../../components/ui/card';

const LABELS = { database: 'Database', api: 'API', ai_service: 'AI Service (GPT-5)', storage: 'Object Storage', job_engine: 'Job Engine', payment_system: 'Payment System' };
const DOT = { operational: 'bg-emerald-500', warning: 'bg-amber-500', error: 'bg-red-500' };

export default function AdminSystem() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/admin/system-health').then(r => setD(r.data)).catch(()=>{}); }, []);
  if (!d) return <AdminLayout title="System Health"><div className="h-64 flex items-center justify-center text-muted-foreground">Memuat...</div></AdminLayout>;
  return (
    <AdminLayout title="System Health">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Object.entries(d.checks).map(([k,v]) => (
          <Card key={k} className="p-5 flex items-center justify-between"><div><div className="font-semibold">{LABELS[k]||k}</div><div className="text-xs text-muted-foreground capitalize mt-0.5">{v}</div></div><span className={`h-3 w-3 rounded-full ${DOT[v]||'bg-slate-400'}`} /></Card>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-4">Diperiksa: {new Date(d.checked_at).toLocaleString('id-ID')}</p>
    </AdminLayout>
  );
}
